import { Fragment } from "react";
import { DoctorCard, Divider } from "components";
import { Doctor } from "types";

interface DoctorsListProps {
  doctors: Doctor[];
  link?: string;
  active?: string;
  isOnline?: boolean;
  onClick?(doctor: Doctor): void;
}

const DoctorsList: React.FC<DoctorsListProps> = ({
  doctors,
  isOnline,
  active,
  link: baseLink,
  onClick,
}) => {
  return (
    <>
      {doctors.map((doctor, index) => {
        const {
          id,
          displayName,
          specialtiesJoined,
          experience,
          price,
          image,
          isPremium,
        } = doctor;
        const description = specialtiesJoined;
        const isActive = active === id;
        const link = baseLink ? `${baseLink}?doctor=${id}` : undefined;
        const handleClick = onClick ? () => onClick(doctor) : undefined;

        return (
          <Fragment key={id + index}>
            <DoctorCard
              name={displayName}
              description={description}
              experience={experience}
              price={{ amount: price, size: 1 }}
              avatar={{ image }}
              premium={isPremium}
              online={isOnline}
              active={isActive}
              link={link}
              onClick={handleClick}
            />
            {index < doctors.length - 1 && <Divider />}
          </Fragment>
        );
      })}
    </>
  );
};

export default DoctorsList;
